export const fromApi = raw => ({
  id: Number(raw.id),
  name: raw.name || '',
  description: raw.description || '',
  fileName: raw.file_name || raw.fileName || '',
  fileType: raw.content_type || raw.fileType || '',
  fileUrl: raw.file_url || raw.fileUrl || '',
  kind: raw.kind || 'file',
  size: Number(raw.byte_size ?? raw.size) || 0,
  createdAt: raw.created_at || raw.createdAt || new Date().toISOString(),
});
